
import CloudRemove from "../../../assets/outline/CloudRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloudRemoveIcon({ className, dataTestid = "CloudRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloudRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
